import { getViewsByParent } from '../BaseTabsRouting/utils';

import DefaultPlaceholderComponent from '../BaseTabsRouting/components/Headers/DefaultPlaceholderComponent';

import { Header } from '../BaseTabsRouting/BaseTabsRouting';
import CleanupCronJobs from './CronJobs/Cleanup/CleanupCronJobs';
import { ImportCronJobs } from './CronJobs/ImportCronJobs/ImportCronJobs';
import SynchronisationCronJobs from './CronJobs/SynchronisationCronJobs/SynchronisationCronJobs';
import TasksCronJobs from './CronJobs/TasksCronJobs/TasksCronJobs';
import Realization from './Realization';
import BasicReports from './Reports/CollectedReports/BasicReports';
import { YearClosure } from './YearClosure/YearClosure';
import { LeaveProcedures } from 'components/admin-portal/Procedures/LeaveProcedures/LeaveProcedures';

export enum MenusOptions {
  IMPORT = 'import',
  IMPORT_EMPLOYEES = 'import_employees',
  REALIZATION = 'realization',
  REPORTS = 'reports',
  YEAR_CLOSURE = 'year_closure',
  EXPORTS = 'exports',
  CRON_JOBS = 'cron_jobs',
  LEAVE_PROCEDURES = 'leave_procedures',
  IMPLEMENTATION_CONFIGURATOR = 'implementation_configurator'
}

export const procedureTableViews = [
  {
    id: 50,
    name: 'IMPORT',
    Component: DefaultPlaceholderComponent,
    parent: MenusOptions.IMPORT
  },
  {
    id: 60,
    name: 'IMPORT_EMPLOYEES',
    Component: DefaultPlaceholderComponent,
    parent: MenusOptions.IMPORT_EMPLOYEES
  },
  {
    id: 70,
    name: 'REALIZATION',
    Component: Realization,
    parent: MenusOptions.REALIZATION
  },
  {
    id: 80,
    name: 'GENERATED_REPORTS',
    Component: BasicReports,
    parent: MenusOptions.REPORTS
  },
  {
    id: 90,
    name: 'YEAR_CLOSURE',
    Component: YearClosure,
    parent: MenusOptions.YEAR_CLOSURE
  },
  {
    id: 100,
    name: 'EXPORTS',
    Component: DefaultPlaceholderComponent,
    parent: MenusOptions.EXPORTS
  },
  {
    id: 110,
    name: 'CRON_JOBS_IMPORT',
    Component: ImportCronJobs,
    parent: MenusOptions.CRON_JOBS
  },
  {
    id: 120,
    name: 'CRON_JOBS_CLEANUP',
    Component: CleanupCronJobs,
    parent: MenusOptions.CRON_JOBS
  },
  {
    id: 130,
    name: 'TASKS',
    Component: TasksCronJobs,
    parent: MenusOptions.CRON_JOBS
  },
  {
    id: 140,
    name: 'SYNC',
    Component: SynchronisationCronJobs,
    parent: MenusOptions.CRON_JOBS
  },
  {
    id: 150,
    name: 'LEAVE_PROCEDURE',
    Component: LeaveProcedures,
    parent: MenusOptions.LEAVE_PROCEDURES
  },
  {
    id: 160,
    name: 'IMPLEMENTATION_CONFIGURATOR',
    Component: DefaultPlaceholderComponent,
    parent: MenusOptions.IMPLEMENTATION_CONFIGURATOR
  }
];

export const procedureHeaders: Header[] = [
  {
    subHeaderName: MenusOptions.IMPORT,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.IMPORT
    )
  },
  {
    subHeaderName: MenusOptions.IMPORT_EMPLOYEES,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.IMPORT_EMPLOYEES
    )
  },
  {
    subHeaderName: MenusOptions.REALIZATION,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.REALIZATION
    )
  },
  {
    subHeaderName: MenusOptions.REPORTS,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.REPORTS
    )
  },
  {
    subHeaderName: MenusOptions.YEAR_CLOSURE,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.YEAR_CLOSURE
    )
  },
  {
    subHeaderName: MenusOptions.EXPORTS,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.EXPORTS
    )
  },
  {
    subHeaderName: MenusOptions.CRON_JOBS,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.CRON_JOBS
    )
  },
  {
    subHeaderName: MenusOptions.LEAVE_PROCEDURES,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.LEAVE_PROCEDURES
    )
  },
  {
    subHeaderName: MenusOptions.IMPLEMENTATION_CONFIGURATOR,
    tabs: getViewsByParent<MenusOptions>(
      procedureTableViews,
      MenusOptions.IMPLEMENTATION_CONFIGURATOR
    )
  }
];
